// store/slices/complexOrderListSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ComplexOrderInterface } from "../../common/types/types";
import { RootState } from "../store";

interface ComplexOrdersState {
  data: ComplexOrderInterface[];
}

const initialState: ComplexOrdersState = {
  data: [],
};

export const complexOrderListSlice = createSlice({
  name: "complexOrderList",
  initialState,
  reducers: {
    setComplexOrders: (
      state,
      action: PayloadAction<ComplexOrderInterface[]>,
    ) => {
      state.data = action.payload;
    },

    addComplexOrder: (state, action: PayloadAction<ComplexOrderInterface>) => {
      state.data.unshift(action.payload);
    },

    clearComplexOrders: (state) => {
      state.data = [];
    },
  },
});

export const { setComplexOrders, addComplexOrder, clearComplexOrders } =
  complexOrderListSlice.actions;

export const selectComplexOrderList = (state: RootState) =>
  state.complexOrderList.data;

export const selectComplexOrderById = (orderId: number) => (state: RootState) =>
  state.complexOrderList.data.find((order) => order.id === orderId);

export default complexOrderListSlice.reducer;
